import React from 'react'
import {imgSrc} from '../../../utils'
const Image = ({image, noImageText = "No image", ...other}) => 
    (image ? <img className="page-image" src={imgSrc(image)}  {...other} /> : noImageText || "No image")

export default Image